<template>
  <div class="deaths-underreporting graphic-container" :class="{ 'graphic-container--social-mode': this.socialMode }">
    <h3 class="chart-hed" v-if="showHeading">Manufacturers classified events “malfunction” or “injury” even when patients died</h3>
    <p v-if="showDeck">ICIJ identified 2,100 cases in a five-year period where people died, but their deaths were not reported as such. Of these, 220 reports showed that devices may have caused or contributed to the deaths.</p>
    <column-chart :chart-height-ratio="baseHeightRatio" :chart-data="data" :chart-options="options"></column-chart>
    <p class="chart-source">Source: U.S. Food and Drug Administration, ICIJ analysis</p>
  </div>
</template>

<script>
  import data from '../assets/deaths-underreporting.json'
  import ColumnChart from '@/components/ColumnChart.vue'
  import embeddable from '../mixins/embeddable'

  export default {
    name: 'DeathsUnderreporting',
    mixins: [embeddable],
    components: {
      ColumnChart,
    },
    data() {
      return {
        data,
        options: {
          chartName: "deaths-underreporting",
          seriesName: "underreportedDeaths",
          labelWidth: "38",
          barColor: "#A83324",
          xAxisTickFormat: this.xAxisYearFormat,
          yAxisTickFormat: function(d) {return d;},
          yAxisTicks: 5,
        }
      }
    }
  }
</script>
